import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCustomers, clearCustomers } from '../../../../actions/index';
import Select from './Select';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { optionsPropTypes } from './SelectPropTypes';
import { DEFAULT_QUERY } from '../../../../config/queries';
import { customersGenerator } from '../../../../utils/app/json-generator-from-reducer';

class CustomerSelect extends Component {
  componentWillUnmount() {
    this.props.dispatchClearCustomer();
  }

  handleCustomerChange = (inputValue) => {
    const { dispatchGetCustomers, searchByDocumentNumber } = this.props;
    if (!searchByDocumentNumber) {
      if (inputValue.trim().length && inputValue.trim().length >= 4) {
        dispatchGetCustomers({ ...DEFAULT_QUERY, query: inputValue });
      }
    } else if (
      inputValue.length &&
      inputValue.length === 8 &&
      !Number.isNaN(Number(inputValue))
    ) {
      dispatchGetCustomers({
        ...DEFAULT_QUERY,
        query: `idDocumentNumber:${inputValue}`,
      });
    }
  };

  render() {
    const {
      options,
      loading,
      noOptionsMessage,
      input,
      meta,
      isDisabled,
      isClearable,
      isMulti,
      autoFocus,
      placeholder,
    } = this.props;

    const props = {
      options,
      onInputChange: this.handleCustomerChange,
      isLoading: loading,
      noOptionsMessage,
      input,
      meta,
      isDisabled,
      isClearable,
      isMulti,
      autoFocus,
      placeholder,
    };

    return <Select {...props} />;
  }
}

const mapStateToProps = ({ UserUnit }, { options }) => {
  const customers = UserUnit.Customer.getIn(['all', 'content', 'content']);

  return {
    options: customers.length === 0 ? options : customersGenerator(customers),
    loading: UserUnit.Customer.getIn(['all', 'loading']),
  };
};

CustomerSelect.propTypes = {
  options: optionsPropTypes,
  loading: PropTypes.bool.isRequired,
  noOptionsMessage: PropTypes.func,
  dispatchGetCustomers: PropTypes.func.isRequired,
  dispatchClearCustomer: PropTypes.func.isRequired,
  input: inputPropTypes,
  meta: metaPropTypes,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  isClearable: PropTypes.bool,
  isMulti: PropTypes.bool,
  autoFocus: PropTypes.bool,
  searchByDocumentNumber: PropTypes.bool,
};

CustomerSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  placeholder: 'Ingrese Nombre o DNI',
  noOptionsMessage: undefined,
  isDisabled: false,
  isClearable: false,
  isMulti: false,
  options: [],
  autoFocus: false,
  searchByDocumentNumber: false,
};
const mapDispatchToProps = {
  dispatchGetCustomers: getCustomers,
  dispatchClearCustomer: clearCustomers,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerSelect);
